import ReportValue from "@frameworks/web/components/generic/commonTableVal";
import React from "react";
const StockLtp = (props) => {
    return (React.createElement("span", { className: "RobotoR_14_400 txt_blackOne1" },
        React.createElement(ReportValue, { val: props.reportVal, stream: false, onlyval: false })));
};
export default StockLtp;
